// extracted by mini-css-extract-plugin
module.exports = {"skeletonAnimation":"skeleton_skeletonAnimation__OXJ6f","loading":"skeleton_loading__ruBXl"};